export default "__VITE_ASSET__frMYy7L$__"